import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";
import { cn } from "lib/utils";

interface TableHeaderItem {
  key: string;
  label: string;
  className?: string;
}

interface ReusableTableProps {
  headers: TableHeaderItem[];
  data: Record<string, any>[];
  /** Optional overrides — kept for backwards compatibility. */
  tableClassName?: string;
  headerClassName?: string;
  bodyClassName?: string;
  rowClassName?: string;
  cellClassName?: string;
  emptyMessage?: string;
}

const DataStatisticsTable: React.FC<ReusableTableProps> = ({
  headers,
  data,
  tableClassName,
  headerClassName,
  bodyClassName,
  rowClassName,
  cellClassName,
  emptyMessage = "There are no campaigns to display.",
}) => {
  return (
    <Table className={cn(tableClassName)}>
      <TableHeader className={headerClassName}>
        <TableRow>
          {headers.map((header) => (
            <TableHead key={header.key} className={cn(header.className)}>
              {header.label}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody className={bodyClassName}>
        {Array.isArray(data) && data.length > 0 ? (
          data.map((item, index) => (
            <TableRow key={index} className={cn(rowClassName)}>
              {headers.map((header, headerIndex) => (
                <TableCell
                  key={header.key}
                  className={cn(
                    cellClassName,
                    headerIndex === 0
                      ? "font-medium text-foreground"
                      : "text-muted-foreground"
                  )}
                >
                  {item[header.key]}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={headers.length}
              className="py-10 text-center text-sm italic text-muted-foreground"
            >
              {emptyMessage}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default DataStatisticsTable;
